import { render } from "./TimKiem.vue?vue&type=template&id=ee0244c2&scoped=true"
import script from "./TimKiem.vue?vue&type=script&lang=js"
export * from "./TimKiem.vue?vue&type=script&lang=js"

import "./TimKiem.vue?vue&type=style&index=0&id=ee0244c2&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0244c2"]])

export default __exports__